//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Services
import { 
    requestGetAcadReinforceTypes 
} from "services/acadReinforce/relatedToAcadReinforce";
import { requestGetAllCampus, requestGetLocations } from "services/general";
//#endregion

const useDataRelatedToFilters = () => {
    //#region States
    const [acadReinforceTypeList, setAcadReinforceTypeList] = useState([]);
    const [locations, setLocations] = useState([]);
    const [campusList, setCampusList] = useState([]);
    const [loadedDataRelatedToFilters, setLoadedDataRelatedToFilters] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        fetchData()
        .then(() => setLoadedDataRelatedToFilters(true));
    }, []);
    //#endregion
    //#region Functions
    const fetchData = async () => {
        await Promise.all([
            fillAcadReinforceTypes(),
            fillLocations(),
            fillCampusList()
        ]);
        setLoadedDataRelatedToFilters(true);
    }
    const fillAcadReinforceTypes = async () => {
        const data = await requestGetAcadReinforceTypes();
        setAcadReinforceTypeList(data);
    }
    const fillLocations = async () => {
        const data = await requestGetLocations();
        setLocations(data);
    }
    const fillCampusList = async () => {
        const data = await requestGetAllCampus();
        setCampusList(data);
    }
    //#endregion
    return {
        loadedDataRelatedToFilters,
        dataRelatedToFilters: {
            acadReinforceTypeList,
            locations, campusList
        }
    };
}

export default useDataRelatedToFilters;